import { useState } from "react";
import Modal from "../common/Modal";
import { useTranslation } from "react-i18next";
import { CREATE_USER_ITEMS } from "./config/create-user";
import { UserService } from "../../services";
import { toast } from "react-toastify";
import {
  doesErrorExistInCreateUserPayload,
  isCreateUserSaveButtonDisabled,
  sanitizeUserDataPayload,
} from "./create-user-modal.helper";

const CreateUserModal = ({
  showAddUserModal,
  handleAddUserClick,
  getUsersList,
  user = {},
}) => {
  const { t } = useTranslation("common");
  const [userData, setUserData] = useState(user);
  const [userError, setUserError] = useState({});

  function handleChange(key, value) {
    setUserData((prev) => ({ ...prev, [key]: value }));
    setUserError({});
  }

  function createNewUser() {
    const checkError = doesErrorExistInCreateUserPayload(userData);
    if (checkError.error) {
      setUserError(checkError);
      return;
    }
    UserService.createUser(sanitizeUserDataPayload(userData))
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(`User created successfully`);
          handleAddUserClick();
          getUsersList();
        } else {
          throw response.data;
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }

  function updateUser() {
    const checkError = doesErrorExistInCreateUserPayload(userData);
    if (checkError.error) {
      setUserError(checkError);
      return;
    }
    UserService.updateUser({
      ...sanitizeUserDataPayload(userData),
      id: user.id,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(`User updated successfully`);
          handleAddUserClick();
          getUsersList();
        } else {
          throw response.data;
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }

  return (
    <div className="ucf-disbursal-popup model-popup-outer create-user-modal">
      <Modal show={showAddUserModal} handleClose={handleAddUserClick}>
        <div className="modal-header">
          <h2>{t("USER_MANAGEMENT.ADD_USER")}</h2>
        </div>
        <div className="modal-body">
          <div className="row">
            {CREATE_USER_ITEMS.map((item) =>
              item.render(
                t,
                showAddUserModal,
                userData,
                handleChange,
                userError
              )
            )}
          </div>
          <button
            className="btn btn-primary"
            disabled={isCreateUserSaveButtonDisabled(userData)}
            onClick={!Object.keys(user).length ? createNewUser : updateUser}
          >
            {t("USER_MANAGEMENT.SAVE_USER")}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default CreateUserModal;
